var alignment_rtlignore_default = {
  "alignLeft": "H-zf9",
  "textWrapNowrap": "hNuRZ",
  "alignRight": "bNyjI",
  "alignCenter": "UDaba",
  "sizeFullWidth": "B2MV6",
  "renderedInTable": "_5SXA-",
  "sizeOriginal": "Xi6RZ",
  "sizeContent": "G9Vm-",
  "sizeSmall": "-Wp-8",
  "sizeSmallCenter": "rCPuD",
  "flex": "LLMIh",
  "LEFT": "MdaVE",
  "CENTER": "-kLVe",
  "RIGHT": "pQ32Y",
  "AUTO": "ojz9r",
  "JUSTIFY": "GhTTp"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
